import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HeroComponent.module.css';
import { MdMic } from 'react-icons/md';

const HeroComponent = () => {
    const navigate = useNavigate();

    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                {/* Left Side Content */}
                <div className={styles.content}>
                    {/* <div className={styles.badge}>
                        <span className={styles.badgeDot}></span>
                        Live AI voice agents — now in production
                    </div> */}
                    <h1 className={styles.headline}>
                        The AI
                        Workforce <br />
                        <span className={styles.gradientText}>Saves Time.</span>
                    </h1>
                    <p className={styles.subheadline}>
                        ToxBox AI deploys intelligent voice agents that answer, qualify, and convert every call — around the clock. Turn your phone lines into a growth engine.
                    </p>
                    <div className={styles.ctaGroup}>
                        <button onClick={() => navigate("/login")} className={styles.primaryBtn}>
                            Try for Free <span className={styles.arrow}>→</span>
                        </button>
                        <button onClick={() => navigate("/demo-form")} className={styles.secondaryBtn}>
                            <span className={styles.playIcon}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 5v14l11-7z" fill="#7c3aed" />
                                </svg>
                            </span>
                            Watch Demo
                        </button>
                    </div>

                    <div className={styles.statsRow}>
                        <div className={styles.statItem}>
                            <h3 className={styles.statNumber}>10M+</h3>
                            <p className={styles.statLabel}>Calls handled</p>
                        </div>
                        <div className={styles.statDivider}></div>
                        <div className={styles.statItem}>
                            <h3 className={styles.statNumber}>98%</h3>
                            <p className={styles.statLabel}>Resolution rate</p>
                        </div>
                        <div className={styles.statDivider}></div>
                        <div className={styles.statItem}>
                            <h3 className={styles.statNumber}>24/7</h3>
                            <p className={styles.statLabel}>Always on</p>
                        </div>
                    </div>
                </div>

                {/* Right Side Mockup */}
                <div className={styles.visuals}>
                    <div className={styles.mockupWrapper}>
                        {/* 3D Floating Spheres & Objects */}
                        <div className={`${styles.sphere} ${styles.spherePurple}`}></div>
                        <div className={`${styles.sphere} ${styles.sphereBlue}`}></div>
                        <div className={`${styles.sphere} ${styles.sphereSmall}`}></div>

                        {/* 3D Torus Donut Shape */}
                        <div className={styles.torusShape}></div>

                        {/* Floating Soundwaves (Behind Phone) */}
                        <div className={styles.bgWaveVisual}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        {/* Headphones Icon (Right Side) */}
                        <div className={styles.headphonesWrapper}>
                            <div className={styles.headphoneBand}></div>
                            <div className={styles.headphoneEarLeft}></div>
                            <div className={styles.headphoneEarRight}></div>
                            <div className={styles.headphoneGlow}></div>
                        </div>

                        {/* Agent Aria Widget */}
                        <div className={styles.ariaWidget}>
                            <div className={styles.ariaPhone}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.57a1 1 0 0 0-1.01.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.2a1 1 0 0 0 .24-1.01 11.285 11.285 0 0 1-.57-3.53c0-.55-.45-1-1-1H3.03c-.55 0-1 .45-1 1C2.03 16.54 13.46 28 27.03 28c.55 0 1-.45 1-1v-4.01c0-.55-.45-1-1-1z" />
                                </svg>
                            </div>
                            <div className={styles.ariaInfo}>
                                <h4>Agent Aria</h4>
                                <p>Answering call...</p>
                            </div>
                            <div className={styles.waveBars}>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>

                        {/* Phone Container Frame */}
                        <div className={styles.phoneFrame}>
                            <div className={styles.phoneHeader}>
                                <div className={styles.cameraNotch}></div>
                            </div>
                            <div className={styles.phoneContent}>
                                <div className={styles.phoneHeadingRow}>
                                    <span className={styles.timeLabel}>9:41</span>
                                    <span className={styles.signalIcon}>📶</span>
                                </div>
                                <div className={styles.agentGreeting}>
                                    <h3>Hi there! 👋</h3>
                                    <p>I'm your AI voice assistant. How can I help you today?</p>
                                </div>

                                <div className={styles.userBubble}>
                                    I can help you answer questions, set reminders, play music, and much more! 🌟
                                </div>

                                <div className={styles.soundWaves}>
                                    <div className={styles.waveLine}></div>
                                    <div className={styles.waveLine}></div>
                                    <div className={styles.waveLine}></div>
                                    <div className={styles.waveLine}></div>
                                </div>

                                <div className={styles.micCircle}>
                                    <span className={styles.micIcon}><MdMic /></span>
                                </div>
                                <span className={styles.micText}>Tap to speak</span>
                            </div>
                        </div>

                        {/* Latency Widget */}
                        <div className={styles.latencyWidget}>
                            <p className={styles.latencyLabel}>Avg response</p>
                            <h4 className={styles.latencyValue}>0.6s</h4>
                        </div>

                        {/* Status Widget */}
                        <div className={styles.liveWidget}>
                            24/7 Live
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroComponent;